<mg-table [collectionComponent]="this" matSort>

    <ng-container matColumnDef="nummer">
        <th mat-header-cell *matHeaderCellDef mat-sort-header pd-size-10> Nummer </th>
        <td mat-cell *matCellDef="let row"> {{row.relatie?.oldID}} </td>
    </ng-container>

	<ng-container matColumnDef="relatie">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Relatie </th>
        <td mat-cell *matCellDef="let row"> {{row.relatie?.naam1}} </td>
    </ng-container>

</mg-table>
